/**
 * Registry of product events that prompt an anonymous user to "claim" their
 * workspace (create an account by verifying a real email).
 *
 * To add a new gate later, add a key here and call
 * `requireClaim('<key>', onProceed)` at the relevant call site — no other
 * wiring required. `mode: 'hard'` blocks the action behind the claim modal;
 * `mode: 'soft'` is reserved for dismissible nudges.
 */
export type ClaimTrigger = 'connect_own_data' | 'build_data_model' | 'save_workspace';

export interface ClaimTriggerConfig {
  mode: 'hard' | 'soft';
  title: string;
  subtitle: string;
}

export const CLAIM_TRIGGERS: Record<ClaimTrigger, ClaimTriggerConfig> = {
  connect_own_data: {
    mode: 'hard',
    title: 'Create your account to connect data',
    subtitle:
      'Verify your email to save this workspace and securely connect your own data sources.',
  },
  build_data_model: {
    mode: 'hard',
    title: 'Create your account to build your data model',
    subtitle:
      'Verify your email to save this workspace and run the AI pipeline that builds your data model.',
  },
  save_workspace: {
    mode: 'hard',
    title: 'Save your workspace',
    subtitle:
      "Verify your email to keep this workspace and everything you've built. Guest workspaces are temporary.",
  },
};
